import React from 'react';
import { useSharedPluginState, sharedPluginStateHookMigratorFactory } from '@atlaskit/editor-common/hooks';
import { TypeAheadAvailableNodes } from '@atlaskit/editor-common/type-ahead';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { TypeAheadMenu as TypeAheadMenuModern } from './modern/TypeAheadMenu';
import { TypeAheadMenu } from './TypeAheadMenu';
var useSharedState = sharedPluginStateHookMigratorFactory(function (api) {
  var triggerHandler = useSharedPluginStateSelector(api, 'typeAhead.triggerHandler');
  var items = useSharedPluginStateSelector(api, 'typeAhead.items');
  var errorInfo = useSharedPluginStateSelector(api, 'typeAhead.errorInfo');
  var decorationElement = useSharedPluginStateSelector(api, 'typeAhead.decorationElement');
  var decorationSet = useSharedPluginStateSelector(api, 'typeAhead.decorationSet');
  var query = useSharedPluginStateSelector(api, 'typeAhead.query');
  var selectedIndex = useSharedPluginStateSelector(api, 'typeAhead.selectedIndex');
  return {
    triggerHandler: triggerHandler,
    items: items,
    errorInfo: errorInfo,
    decorationElement: decorationElement,
    decorationSet: decorationSet,
    query: query,
    selectedIndex: selectedIndex
  };
}, function (api) {
  var _useSharedPluginState = useSharedPluginState(api, ['typeAhead']),
    typeAheadState = _useSharedPluginState.typeAheadState;
  return {
    triggerHandler: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.triggerHandler,
    items: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.items,
    errorInfo: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.errorInfo,
    decorationElement: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.decorationElement,
    decorationSet: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.decorationSet,
    query: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.query,
    selectedIndex: typeAheadState === null || typeAheadState === void 0 ? void 0 : typeAheadState.selectedIndex
  };
});
export function ContentComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    popupMountRef = _ref.popupMountRef;
  var _useSharedState = useSharedState(api),
    triggerHandler = _useSharedState.triggerHandler,
    items = _useSharedState.items,
    errorInfo = _useSharedState.errorInfo,
    decorationElement = _useSharedState.decorationElement,
    decorationSet = _useSharedState.decorationSet,
    query = _useSharedState.query,
    selectedIndex = _useSharedState.selectedIndex;
  if (items === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) {
    return null;
  }
  if (
  // TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
  !editorExperiment('platform_editor_insertion', 'control') && (triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.id) === TypeAheadAvailableNodes.QUICK_INSERT) {
    return /*#__PURE__*/React.createElement(TypeAheadMenuModern, {
      editorView: editorView,
      popupMountRef: popupMountRef,
      typeAheadState: {
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        decorationElement: decorationElement,
        decorationSet: decorationSet,
        query: query
      },
      api: api
    });
  } else {
    return /*#__PURE__*/React.createElement(TypeAheadMenu, {
      editorView: editorView,
      popupMountRef: popupMountRef,
      typeAheadState: {
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        decorationElement: decorationElement,
        decorationSet: decorationSet,
        query: query
      },
      selectedIndex: selectedIndex,
      api: api
    });
  }
}